import { useCallback, useEffect, useRef } from "react";

/**
 * For "Show more" on a paged list: `key` names the list on screen (its
 * filters, and when its first page last arrived). Call the returned function
 * before asking for a page; it gives back a check that's true only while
 * that list is still the one on screen, so a page that arrives after the
 * filter changed, or the list refreshed, is dropped instead of being added
 * to the wrong list.
 */
export function usePageGuard(key: string): () => () => boolean {
  const current = useRef(key);
  useEffect(() => {
    current.current = key;
  }, [key]);
  return useCallback(() => {
    const askedFor = current.current;
    return () => current.current === askedFor;
  }, []);
}
